// extracted by mini-css-extract-plugin
export default {"menuButton":"CalcMenuButton_menuButton__H2Dts"};